import { render, staticRenderFns } from "./card-review-hsia-grid.vue?vue&type=template&id=499e1783&scoped=true&"
import script from "./card-review-hsia-grid.vue?vue&type=script&lang=js&"
export * from "./card-review-hsia-grid.vue?vue&type=script&lang=js&"
import style0 from "./card-review-hsia-grid.vue?vue&type=style&index=0&id=499e1783&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499e1783",
  null
  
)

export default component.exports